import React from 'react';

import { GqlDispensaries } from 'types/graphql';

import useMediaQuery from 'shared/hooks/use-media-query';
import { DesktopHeader } from './desktop-header';
import { MobileHeader } from './mobile-header';
import { InfoBar } from './info-bar';
import { InfoBarMq } from './header.styles';
import { LoginNudgeProvider } from './login-nudge/login-nudge-context';

type NavigationProps = {
  dispensary: GqlDispensaries;
  isAccountEnabled: boolean;
};

export const Navigation = ({ dispensary, isAccountEnabled }: NavigationProps): JSX.Element => {
  const isDesktop = useMediaQuery('(min-width: 880px)');

  return (
    <>
      <LoginNudgeProvider>
        {isDesktop && <DesktopHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />}
        {!isDesktop && <MobileHeader dispensary={dispensary} isAccountEnabled={isAccountEnabled} />}
      </LoginNudgeProvider>

      <InfoBarMq>
        <InfoBar />
      </InfoBarMq>
    </>
  );
};
